import * as requests from "../API/requests";

const authStore = {
  namespaced: true,
  state: () => ({
    token: "",
    user: "",
    accountStatus: "",
    data: "",
    notifications: {},
    notification_last_fetched_at: null,
    displayNewFeatureModal: true,
  }),
  mutations: {
    setToken(state, payload) {
      state.token = payload;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setAccountStatus(state, payload) {
      state.accountStatus = payload;
    },
    setData(state, payload) {
      state.data = payload;
    },
    setNotifications(state, payload) {
      state.notifications = payload;
    },
    setNotificationLastFetchedAt(state, payload) {
      state.notification_last_fetched_at = payload;
    },
    setShouldDisplayNewFeatureModal(state, payload) {
      state.displayNewFeatureModal = payload;
    },
  },
  actions: {
    async loginUser(store, payload) {
      const login = await requests.loginRequest(payload);
      store.commit("setToken", login.authToken);
      return login;
    },
    async checkAccountStatus(store) {
      const status = await requests.checkAccountStatusRequest();

      store.commit("setAccountStatus", status);
      return status;
    },
    async checkAuthStatus() {
      const status = await requests.checkAuthStatusRequest();
      return status;
    },
    async loadData(store) {
      const response = await requests.getUserDataRequest();

      store.commit("setData", response);
      return response;
    },
    async loadRoute(store) {
      const response = await requests.getAuthRedirectRouteUrlRequest();
      store.commit("setUser", response);
      return response;
    },
    async signUpUser(store, payload) {
      const response = await requests.signUpRequest(payload);
      store.commit("setToken", response.authToken);
      return response;
    },
    async getGoogleAuthUrl(_, params) {
      const response = await requests.googleAuthUrlRequest(params);
      return response;
    },
    async continueGoogleSignUp(_, payload) {
      const response = await requests.googleSignUpContinueRequest(payload);
      return response;
    },
    async sendForgotPasswordEmail(store, payload) {
      const response = await requests.sendForgotPasswordEmailRequest(payload);
      return response;
    },
    async validatePasswordResetToken(store, payload) {
      const response = await requests.validatePasswordResetTokenRequest(
        payload
      );
      return response;
    },
    async resetPassword(store, payload) {
      const response = await requests.resetPasswordRequest(payload);
      return response;
    },
    async resendEmailBackup(store, payload) {
      const response = await requests.resendEmailBackupRequest(payload);
      return response;
    },
    async getUserDetails() {
      const response = await requests.checkAuthStatusRequest();
      return response;
    },
    async getToken() {
      return await requests.getTokenRequest();
    },
    async getChecklist() {
      return await requests.loadChecklistRequest();
    },
    async getAccountSettingsUserData() {
      return await requests.accountSettingsUserDataRequest();
    },
    async verifyEmailCode(_, payload) {
      console.log("request payload", payload);
      return await requests.verifyEmailCodeRequest(payload);
    },
    async accountSettingsResetPassword(_, payload) {
      return await requests.accountSettingsResetPasswordRequest(payload);
    },
    async accountSettingsUploadProfile(_, payload) {
      return await requests.accountSettingsUploadProfileRequest(payload);
    },
    async getSubscriptionData() {
      return await requests.getSubscriptionDetailsRequest();
    },
    async getNotifications(store) {
      const response = await requests.getNotificationsRequest();
      store.commit("setNotifications", response);
      store.commit("setNotificationLastFetchedAt", new Date());
      return response;
    },
  },
  getters: {
    data(state) {
      return {
        fname: state.data.result_1?.firstname,
        ff_no: state.data.financial_data?.ffnumber.ffnumber,
        difference: state.data.financial_data?.years.difference,
        income: state.data.payload?.income,
        savings: state.data.payload?.savings,
        rate: state.data.payload?.savings_rate,
        ff_no_desc: state.data.financial_data?.ffnumber.ffnumber_desc,
        age_no_ap: state.data.financial_data?.age.age_no_ap,
        age_ap: state.data.financial_data?.age.age_ap,
        age_today: state.data.financial_data?.age.age_today,
        rate_message: state.data.payload?.message,
        kyc: state.data.payload?.kyc,
        stage: state.data.result_1?.login.stage,
        bgColor: state.data.payload?.bgColor,
        color: state.data.payload?.color,
        p_image: state.data.payload?.profile,
      };
    },
    notifications(state) {
      return state.notifications;
    },
  },
};

export default authStore;
